import { createTheme, responsiveFontSizes } from "@mui/material/styles";

let theme = createTheme({
  palette: {
    primary: {
      main: "rgba(238, 190, 98, 0.12)",
      contrastText: "#EEBE62",
    },

    text: {
      primary: "#fff",
      secondary: "#FDFCFC",
    },
  },
  modalColors: {
    modalbg: "#1E293B",
    textColor: "#FFFFFF",
    font: "interBold",
    cros: "#E61F43",
    contextColor: "#94A3B8",
    box: {
      maxWidth: "auto",
      height: "100px",
      background:
        "linear-gradient(94.25deg, #EEBE62 0%, #9C702A 31.82%, #EEBE62 75.71%, #9C702A 98%)",
      borderRadius: "0px",
    },
  },
  typography: {
    fontFamily: "Roboto",
    h1: {
      fontWeight: 900,
      fontSize: "90px",
    },
    h2: {
      fontWeight: 700,
      fontSize: "60px",
    },
    h3: {
      fontWeight: 400,
    },
  },
});

theme.overrides = {
  MuiCssBaseline: {
    "@global": {
      body: {
        fontFamily: "Roboto",
        backgroundColor: "#000a19",
        color: "#ffffff",
      },
      ".img-fluid": {
        maxWidth: "100%",
        height: "auto",
      },
    },
  },
};

theme = responsiveFontSizes(theme);

export default theme;
